import React from 'react';
import ReactCrop from 'react-image-crop';
import '../../../styles/onboardingStep1.css';
import '../onboarding/onboarding3.css';
import Modal from 'react-bulma-components/lib/components/modal';
import 'react-image-crop/dist/ReactCrop.css';
import Button from 'react-bulma-components/lib/components/button';
import '../../../styles/uploadimage.css';
import '../../../styles/myProfile.css'
import superagent from 'superagent';
import { Redirect } from 'react-router-dom';
// import { image64toCanvasRef, base64StringtoFile, downloadBase64File, extractImageFileExtensionFromBase64 } from '../reusable';
import resizer from 'image-resizer-js';
// import '../../../styles/toolbar_replace.css'
// import '../../../styles/toolbar.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import ReactTelInput from 'react-telephone-input';
import { CountryDropdown, RegionDropdown, CountryRegionData } from 'react-country-region-selector';
const getInitialState = () => ({

    imageCropped: false,
    showCropMode: false,
    cropDetails: {},
    modifiedImages: [],
    selectedOriginalImageUrl: '',
    selectedOriginalImage: null,
    selectedFile: null,
    wantsToEditInterest: false,
    wantsToEditStylePreferences: false,
    savedDetails: false,
    country: ""
});
const MAX_IMAGES = 1;
export default class Addresses extends React.Component {

    constructor(props) {
        super(props);
        this.imagePreviewCanvasRef = React.createRef()
        this.state = getInitialState();
    }



    handleEditInterestsClick() {
        this.setState({
            wantsToEditInterest: true
        })
    }

    handleEditStylePrefsClick() {
        this.setState({
            wantsToEditStylePreferences: true
        })
    }

    selectCountry(item) {
        this.setState({
            country: item
        })
    }
    render() {

        if (this.state.wantsToEditInterest) {
            return (
                <Redirect push to="/onboardingone" />
            )
        }
        if (this.state.wantsToEditStylePreferences) {

            return (
                <Redirect push to="/onboardingtwo" />
            )
        }
        if (this.state.savedDetails) {

            return (
                <Redirect push to="/myprofile" />
            )
        }
        return (
            <div className="back">

                <div className="heading-welcome">
                    YOUR ADDRESSES
                    <hr className="line-category-name margin-auto"></hr>
                </div>
                <div className="container onboardingStep3 editProfile addresses-block">
                    <div className="content-onboarding-step">
                        <div className="heading-text">
                            <div className="onboarding-question">
                                Delivery Address
                            </div>
                        </div>

                        <div className="user-profile-form-section">
                            <div className="profile-details-country-dropdown">
                                <p className="form-section-name-user-profile">ADDRESS LINE 1</p>
                                <input className="form-element-small-input" />
                            </div>
                            <div className="profile-details-country-dropdown">
                                <p className="form-section-name-user-profile">ADDRESS LINE 2</p>
                                <input className="form-element-small-input" />
                            </div>
                            <div className="profile-details-dropdown-container">
                                <div className="profile-details-country-dropdown">
                                    <p className="form-section-name-user-profile ml25">CITY</p>
                                    <input className="form-element-small-input ml25" />
                                </div>
                                <div className="profile-details-country-dropdown ml-25">
                                    <p className="form-section-name-user-profile ml-0">STATE</p>

                                    <input className="form-element-small-input mr25" />
                                </div>
                            </div>
                            <div className="profile-details-dropdown-container">

                                <div className="profile-details-country-dropdown">
                                    <p className="form-section-name-user-profile">COUNTRY</p>

                                    <CountryDropdown className="form-element-small-input"
                                        value={this.state.country}
                                        onChange={(val) => this.selectCountry(val)}
                                    />
                                    {/* <ReactTelInput
                                        defaultCountry="in"
                                        flagsImagePath='/path/to/images/flags.png'
                                        // onChange={handleInputChange}
                                        // onBlur={handleInputBlur}
                                    /> */}
                                    <div className="profile-details-country-dropdown">
                                        <p className="form-section-name-user-profile">ZIP</p>
                                        <input className="form-element-small-input" />
                                    </div>
                                </div>
                            </div>



                            <div className="col-md-12 text-left ml-15">

                                <input type="submit" name="submit" className="masterpieces-primary-buttons btn-primary"
                                     value="SAVE ADDRESS" style={{ "marginTop": 25 }} />

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Home/profile/addresses.js